/* Global imports. */
import React from "react";

interface Props {
  twitterTimelineUrl: string;
}

const TwitterTimeline = ({ twitterTimelineUrl }: Props) => <div className="twitter-embed" dangerouslySetInnerHTML={{ __html: twitterTimelineUrl }} />;

export default TwitterTimeline;